import React from 'react'
import {MailAddrForm} from './mailaddrform.react.js'
import {MsgBox} from './msgbox.react.js'

export const RegisterForm = React.createClass({
  getInitialState() {
    return {
      showMsgBox: false,
    };
  },

  close: function(e) {
    this.setState({showMsgBox:false})
  },

  onRegister(e, mailaddr) {
    this.props.close(e)

    const vals = {
      mailaddr,
    };

    // post login
    $.ajax({
      url: '/submit_register',
      type: 'POST',
      data:vals
    }).done((data) => {
      if (data.result) {
        this.setState({showMsgBox:true})
      }
      else {
        alert("正しいメールアドレスを入力してください")
      }
    })
  },

  render: function() {
    return (
      <div>
        <MsgBox showModal={this.state.showMsgBox} close={this.close} onok={this.close} caption='ユーザ登録'
          msg={`確認用のメールを送信しました。
メールを確認して、リンクをクリックしてください。`}/>

        <MailAddrForm caption="ユーザ登録" okbutton="登録" showModal={this.props.showModal}
          close={this.props.close} onsubmit={this.onRegister}/>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./components/register.react.js